import { HttpClient, HttpHandler } from '@angular/common/http';
import { Injectable } from '@angular/core';

export type HttpClientParams = Record<string, string | string[]>;

@Injectable()
export class ApiService extends HttpClient {
  constructor(defaultHandler: HttpHandler) {
    super(defaultHandler);
  }
}
